module.exports = __webpack_public_path__ + "static/media/covidend-global-logo.40d97435.png";